export abstract class IComputationTimeRepository {
    public abstract increase(balance: number, payload: number): number;
    public abstract decrease(balance: number, payload: number): number;
}